export function ExpandedRowsMobile({
    data,
    columns,
}: {
    data: any;
    columns: any;
}) {
    return (
        <div className="flex flex-col gap-4 p-4 sm:hidden">
            {columns
                .filter((col: any) => col.meta?.mobileHidden && col.id !== 'actions' && col.id !== '')
                .map((column: any) => {
                    let headerText = column.accessorKey;
                    if (typeof column.header === 'function') {
                        const headerElement = column.header({ column: {} });
                        if (headerElement?.props?.children) {
                            headerText = headerElement.props.children;
                        }
                    }

                    const cellValue = typeof column.cell === 'function'
                        ? column.cell({ row: { original: data } })
                        : data[column.accessorKey];

                    return (
                        <div key={column.id || column.accessorKey} className="flex flex-col gap-1">
                            <span className="font-semibold text-sm text-gray-600">
                                {headerText}
                            </span>
                            <div className="text-sm [&_*]:!font-normal [&_*]">{cellValue}</div>
                        </div>
                    );
                })}
        </div>
    );
}
